import React, { useEffect, useState } from 'react';
import PrevIcon from "../../../../assets/icons/coloredPrev.svg";
import "./CheckOutDecision.css";
import billImage from "../../../../assets/HotelGuide/bill.png";
import { useLocation, useNavigate } from 'react-router-dom';
import CheckOutDecCard from './CheckOutDecCard';
import useAuth from "../../../../customHooks/useAuth"
import Remarks from '../../../components/Remarks/Remarks'; 

export default function CheckOutDecision() {

    const navigate = useNavigate();
    const location = useLocation();


    const bookedRoomId = location.state?.bookedRoomId || "";
    const bookingId = location.state?.bookingId || "";
    const requestId = location.state?.requestId || "";
    const userId = location.state?.userId || "";
    const status = location.state?.status || "";
    const Data = location.state?.Data || {};
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const people = location.state?.people || "";
    const roomNumber = location.state?.roomNumber || "";

 
    // Move to bookings if the id is not present 
    useEffect(()=>{
        const checkData = ()=>
        {
     
            if(requestId==="" || userId==="" ){
                navigate("/bookings");
            }
        }
        checkData();
    },[requestId,userId,navigate]);

 
    // Refresh Hanlde
    useAuth();

    const moveBack = ()=>{
        navigate("/bookings",{state : {activeRequests : "requests"}})
    }

  
    return (
        <>
            {
                status==="Pending_Hotel" ? 
            
                <div style={{display: "flex",justifyContent: "center",alignItems:"center",margin : "auto",minHeight : "auto"}}>
                    <h2>Pending From Hotel Side Please Wait...</h2>
                </div> 
            
            : 
            
    
                <div className="checkoutDecision">
                    {/* Header */}
                    <div className="bill-header">
                        <div className="bill-header-content">
                            <div className="prevIcon" onClick={moveBack}>
                                <img src={PrevIcon} alt="prev"  />
                            </div>
                            <div className="bill-header-data">
                                <h4>Bill Details - Room #{roomNumber}</h4>
                                <h5>
                                    <span>
                                        &#x25CF; <span style={{ paddingLeft: "10px" }}>{checkInDate} - {checkOutDate}</span>   
                                    </span>
                                    <span style={{ marginLeft: "12px" }}>
                                        &#x25CF; <span style={{ paddingLeft: "10px" }}>{people} people</span>  
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>

                    {/* Remarks */}
                    <Remarks para = "Please clear your bill on the Reception"/>

                    {/* Bill Data */}
                    <div className="bill-data">
                        
                        {Data.bills &&
                            Data.bills.map((bill, index) => 
                            !(bill.bills===null || bill.total===null )&& (
                                <CheckOutDecCard
                                    billImage = {billImage}
                                    total = {bill.total}
                                    type  = {bill.type}
                                    key = {index}
                                    billImgArr = {bill.bills}
                                    id = {bill.guest_request_id}
                                />
                            )
                        )}

                    </div>




                    {/* Cancel Button */}
                    <div className="pay-btn">
                        <h4>
                            Total Amount : {Data.total_amount || "0"} ₹
                        </h4>
                        {/* <button>Pay Now</button> */}
                        
                    </div>
                </div>
            }
        </>
    );
}
 